<ng-container *ngIf="mentionsLegalesHtml$ | async as mentionsLegalesHtml">
    <lib-markdown pageTitle="Mentions légales" [markdownAsHtml]="mentionsLegalesHtml"></lib-markdown>
</ng-container>
